import { toBn } from './utils';

export const taka = (amount) => `৳${toBn(amount)}`;

// Discount badge only makes sense when both prices exist and the regular one is higher.
export function discountPercent({ price, regularPrice }) {
  if (price == null || regularPrice == null || regularPrice <= price) return null;
  return Math.round((1 - price / regularPrice) * 100);
}

export const CLOSED_LABEL = 'ভর্তি এখন বন্ধ';
